<div class="page-section-container">
  <div class="page-section title primary-background">
    <title-small-section></title-small-section>
  </div>

  <div class="page-section">
    <div class="policy-container" [innerHTML]="globalElements()?.termsAndConditions"></div>
  </div>
</div>
